"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackProviderImpl = void 0;
var Utils_1 = require("../../../utils/Utils");
var uuid_1 = require("uuid");
var UserCache_1 = require("./../../UserCache");
var Future_1 = require("../../../utils/Future");
var CoreServiceHelper_1 = require("../airabbi/CoreServiceHelper");
var FeedbackProviderImpl = (function () {
    function FeedbackProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " FeedbackProviderImpl#")], args, false));
            }
        };
        this.log('FeedbackProviderImpl# created!');
    }
    FeedbackProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return Promise.resolve();
    };
    FeedbackProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    FeedbackProviderImpl.prototype.createFeedback = function (uid, title, content, screenshotUrl, ccList) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!uid || uid === '') {
            return Promise.reject('uid cannot be empty!');
        }
        if (!title || title === '') {
            return Promise.reject('title cannot be empty!');
        }
        if (!content || content === '') {
            return Promise.reject('content cannot be empty!');
        }
        var feedback = {
            id: (0, uuid_1.v4)(),
            uid: uid,
            title: title,
            user: currentUser,
            host: window.location.host,
            pathname: window.location.pathname,
            url: window.location.href,
            screenshotUrl: screenshotUrl ? screenshotUrl : '',
            content: content,
            updated: Date.now()
        };
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/feedbacks/").concat(feedback.id);
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .patchData('feedbacks', {
            unit: currentUser.unit,
            id: feedback.id
        }, feedback)
            .then(function () {
            var feedbackBody = Object.keys(feedback).reduce(function (arr, key) {
                return arr + "<div>".concat(key, ": ").concat(JSON.stringify(feedback[key]), "</div>");
            }, '');
            var mailBody = "<div>creator:".concat(currentUser.email, " ").concat(currentUser.displayName, "</div>") +
                "<div>title:".concat(title, "</div>") +
                "<div>content:".concat(content, "</div>") +
                "<div>Time:".concat((0, Utils_1.getTimeString)(), "</div>") +
                feedbackBody +
                "<div>screenshotUrl:<a href=\"".concat(screenshotUrl, "\">Screenshot</a></div>");
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .sendEmailEx(['jerry@airabbi.com'], '[Feedback] CodingBar', mailBody, ccList)
                .then(function () {
                future.resolve();
            })
                .catch(function (err) {
                future.reject(err);
            });
        })
            .catch(function (err) { return future.reject(err); });
        return future.promise;
    };
    FeedbackProviderImpl.prototype.getFeedback = function (id) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!id || id === '') {
            return Promise.reject('id cannot be empty!');
        }
        var path = "/units/".concat(currentUser.unit, "/feedbacks/").concat(id);
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('feedbacks', {
            unit: currentUser.unit,
            id: id
        }, {}, {}, '')
            .then(function (response) {
            var feedback = response.result ? response.result[0] : undefined;
            return Promise.resolve(feedback);
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    FeedbackProviderImpl.prototype.getFeedbacks = function (uid) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!uid || uid === '') {
            return Promise.reject('uid cannot be empty!');
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryData('feedbacks', {
            unit: currentUser.unit,
            uid: uid
        }, {}, {}, '')
            .then(function (response) {
            var feedbacks = response.result ? response.result : [];
            return Promise.resolve(feedbacks);
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    FeedbackProviderImpl.prototype.removeFeedback = function (id) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!id || id === '') {
            return Promise.reject('id cannot be empty!');
        }
        var path = "/units/".concat(currentUser.unit, "/feedbacks/").concat(id);
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).removeData('feedbacks', {
            unit: currentUser.unit,
            id: id
        });
    };
    FeedbackProviderImpl.prototype.updateFeedback = function (id, feedback) {
        var currentUser = (0, UserCache_1.loadUser)();
        if (!feedback) {
            return Promise.reject('feedback cannot be empty!');
        }
        var path = "/units/".concat(currentUser.unit, "/feedbacks/").concat(feedback.id);
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg).patchData('exercises', {
            unit: currentUser.unit,
            id: feedback.id
        }, feedback);
    };
    FeedbackProviderImpl.prototype.stopAllMonitor = function () {
    };
    return FeedbackProviderImpl;
}());
exports.FeedbackProviderImpl = FeedbackProviderImpl;
//# sourceMappingURL=FeedbackProviderImpl.js.map